import {createActions} from 'client/framework';

export default createActions(null, [
  'PAGE_CHANGED',
  'SET_ACTIVE_PAGE',
  'SET_PAGE_LIST_WINDOW_INDICES',
  'RESET_STORE'
]);
